import * as React from 'react';

const NetworkWideVisibilityIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    fill="none"
    stroke="currentColor"
    strokeLinejoin="round"
    strokeWidth="2"
  >
    <path
      d="M21,12a8.31,8.31,0,0,1-8.35,8.35h0M21,12a8.31,8.31,0,0,0-8.35-8.35M21,12H13.11m-.46,8.35a8.93,8.93,0,0,1-3.06-.56m3.06.56c1.58,0,2.78-3.71,2.78-8.35s-1.2-8.35-2.78-8.35m-2.6,5.47c.37-3.15,1.39-5.47,2.6-5.47m-8,6a8.38,8.38,0,0,1,8-6"
      strokeLinecap="round"
    />
    <path d="M3,19.79l3.15-3.15Z" />
    <path d="M6.15,16.64a2.7,2.7,0,0,0,3.9,0,2.7,2.7,0,0,0,0-3.9,2.7,2.7,0,0,0-3.9,0,2.7,2.7,0,0,0,0,3.9Z" />
  </svg>
);

export default NetworkWideVisibilityIcon;
